
<template>
  <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
      <span>{{name}}</span>
    </div>
    <div class="text item paramContainer"> 
      <el-row :gutter="10">
        <el-col class="paramNameCol" :span="8">
            This action has no parameters to configure. 
        </el-col>
      </el-row>  
      
      <div class="tip">
          {{desc}}
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'AvitoRegistration',
  data () {
    return {
      name: 'Avito Registration',
      desc: 'Don\'t forget to select Account Group and Registration Policy in your settings.',
    }
  }, 
  props: {
      model: {
          type: Object,
          default: () => {}
      },
  },
  methods: {
   
  },
}
</script>
